export enum InvoiceStatus {
    Paid = 1,
    Due = 2,
    Cancelled = 3,
    Locked = 4
}
